var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"spinner-container"},[_c('blade-spinner',{attrs:{"nested":"","background-color":"rgba(0,0,0,0)","spinner-color":"#212529"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropin-container"},[_c('div',{ref:"dropinTarget"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3693716c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/braintree/DropinContainer.vue
// module id = null
// module chunks = 